;(function (angular, _) {
  'use strict'

  class EditCustomFieldsController {
    constructor (
      // Angular
      $q,
      // Libs
      $uibModal,
      // Managers
      CustomFieldManager,
      // Services
      SnackService,
      // Const
      // Resolved
      DisplayService
    ) {
      this.q = $q
      this.modal = $uibModal
      this.manager = CustomFieldManager
      this.snackService = SnackService
      this.displayService = DisplayService
      this.textValidation = /^[a-z0-9\-_]+\w$/i
      this.instanceId = Math.random().toString(36).substring(7)
    }

    $onInit () {
      this.createNewField()
    }

    $onChanges (changes) {
      if (changes.customFields?.currentValue) {
        this.ensureIndexes()
      }
      if (changes.model?.currentValue) {
        this.createNewField()
      }
    }

    createNewField () {
      const managerField = this.manager.create({
        model: this.model,
        options: {
          index: this.maxIndex,
          size: 2,
          required: false
        }
      })
      this.newField = managerField
      this.newField.instanceId = this.instanceId
      this.newField.model = this.model
    }

    checkRequirementField(field) {
      if (!field) return
      const initialRequirement = field.options.required

      if (field.type === 'Boolean') {
        field.options.required = false
      } else {
        field.options.required = initialRequirement
      }
    }

    get maxIndex () {
      let index = _.max(this.customFields.map(c => _.get(c, 'options.index')))
      if (!index || index === -Infinity) {
        index = 0
      }
      return index
    }

    promptOptions (field) {
      this.modal.open({
        size: 'xl',
        resolve: {
          field: [function () {
            return field
          }],
          model: [() => this.model]
        },
        templateUrl: '/app/common/components/edit-customfields/option-modal.html',
        controller: ['field', 'model', '$uibModalInstance', function (field, model, $uibModalInstance) {
          var self = this

          self.$onInit = () => {
            _.extend(self, {
              // Public attributes
              field: angular.copy(field),
              model: angular.copy(model),
              // Public Methods
              add: addValue,
              close: close,
              dismiss: $uibModalInstance.dismiss,
              down: downOption,
              remove: removeValue,
              up: upOption
            })
          }

          function addValue () {
            if (!_.get(this.field, 'options.options')) _.set(this.field, 'options.options', [])
            self.field.options.options.push(self.newValue)
            self.newValue = ''
          }

          function removeValue ($index) {
            self.field.options.options.splice($index, 1)
          }

          function upOption ($index) {
            switchPositionOption($index, $index - 1)
          }

          function downOption ($index) {
            switchPositionOption($index, $index + 1)
          }

          function switchPositionOption (index1, index2) {
            var copy = angular.copy(self.field.options.options[index1])
            self.field.options.options[index1] = angular.copy(self.field.options.options[index2])
            self.field.options.options[index2] = copy
          }

          function close () {
            _.extend(field, self.field)
            $uibModalInstance.close()
          }
        }],
        controllerAs: 'ctrl'
      })
    }

    up (field) {
      this.switchPosition(field, 'up')
    }

    down (field) {
      this.switchPosition(field, 'down')
    }

    switchPosition (field, direction) {
      const index = _.get(field, 'options.index')
      let switchIndex = direction === 'down' ? index + 1 : index - 1
      const found = this.customFields.find((c) => c.options.index === switchIndex)
      _.set(field, 'options.index', switchIndex)
      _.set(found, 'options.index', index)
      field.save()
      found.save()
    }

    slugify (string) {
      return string.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w-]+/g, '')       // Remove all non-word chars
        .replace(/--+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '')            // Trim - from end of text
    }

    generateKey (field) {
      var keys = _.map(_.filter(angular.copy(this.customFields), function (f) { return f._id !== field._id }), 'key')
      if (!field.label) {
        field.key = ''
        return
      }
      var newKey = this.slugify(field.label.substr(0, 18))
      while (_.includes(keys, newKey)) {
        if (!isNaN(newKey[newKey.length - 1])) {
          var v = newKey[newKey.length - 1]
          newKey = newKey.slice(0, -1)
          newKey += (parseInt(v) + 1)
        } else {
          newKey += '-1'
        }
      }
      field.key = newKey
    }

    remove (field) {
      this.displayService.confirmDeletion().then( () => {
        field.remove().then( () => {
          _.remove(this.customFields, function (f) {
            return field._id === f._id
          })
          this.snackService.snack({
            text: 'Champ supprimé !',
            delay: 3000
          })
        })
      })
    }

    save (field) {
      _.set(field, 'options.values', null)
      if (field.type === 'File') {
        _.set(field, 'options.mobile', false)
      }
      var exist = !!field._id
      if (!exist) {
        _.set(field, 'options.index', this.maxIndex + 1)
      }
      field.save().then(() => {
        if (!exist) {
          this.customFields.push(field)
          this.newField = this.manager.create({
            model: this.model,
            options: {
              index: this.maxIndex,
              size: 2,
              required: false
            }
          })
        }
        this.snackService.snack({
          text: 'Champ ' + (exist ? 'modifié !' : 'sauvegardé !'),
          delay: 3000
        })
      })
    }

    /**
     * Re arrange index on each custom fields
     */
    ensureIndexes () {
      this.customFields.forEach((custom) => {
        if (custom.options?.values && custom.options?.values.length) {
          custom.options.options = custom.options.values
          custom.options.values = null
        }
      })
      const sortCustomFields = (fields) => {
        let promises = []
        let cfs = fields.sort((a, b) => {
          const indexA = _.get(a, 'options.index', -Infinity)
          const indexB = _.get(b, 'options.index', +Infinity)
          return indexA < indexB ? -1 : indexA > indexB ? 1 : 0
        })
        cfs.forEach((c, index) => {
          const oldIndex = _.get(c, 'options.index')
          if (oldIndex !== index) {
            _.set(c, 'options.index', index)
            promises.push(c.save())
          }
        })
        if (!promises.length) {
          return
        }
        this.q.all(promises).then(() => {
          function sortIndexes (a, b) {
            return a < b ? -1 : a > b ? 1 : 0
          }
          const indexes = cfs.map(c => c.options.index).sort(sortIndexes)
          const uniqueIndexes = _.uniq(indexes).sort(sortIndexes)
          // If indexes !==  uniqueIndexes, it means that we have two custom fields with same index
          if (!compareArrays(indexes, uniqueIndexes)) {
            sortCustomFields(cfs)
          }
        })
      }

      function compareArrays (a = [], b = []) {
        if (a.length !== b.length) {
          return false
        }
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false
          }
        }
        return true
      }

      sortCustomFields(this.customFields)
    }
  }

  EditCustomFieldsController.$inject = [
    // Angular
    '$q',
    // Libs
    '$uibModal',
    // Managers
    'CustomFieldManager',
    // Services
    'SnackService',
    // Const
    // Resolved
    'DisplayService'
  ]

  angular.module('kilo.common.components')
    .component('editCustomFields', {
      bindings: {
        model: '@',
        customFields: '<'
      },
      templateUrl: '/app/common/components/edit-customfields/edit-customfields.html',
      controller: EditCustomFieldsController
    })
})(window.angular, window._)
